import * as React from "react";
const SvgIcMenuArrowDownAlt = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.833 8.333 10 12.5l4.167-4.167H5.833Z" /></svg>;
export default SvgIcMenuArrowDownAlt;